import React, { forwardRef, useEffect, useState } from "react";

// prop-types is a library for typechecking of props
import PropTypes from "prop-types";

import CreatableSelect from "react-select/creatable";
import { ActionMeta, OnChangeValue } from "react-select";

// Soft UI Dashboard PRO React base styles
import colors from "assets/theme/base/colors";

// Custom styles for SuiSelect
import styles from "components/SuiSelect/styles";

const SuiSelect = forwardRef(({ size, error, success, ...rest }, ref) => {
  const { light } = colors;
  const [options, setOptions] = useState(rest.options);
  const [value, setValue] = useState(rest.value);

  const handleChange = (newValue, actionMeta) => {
    console.group("Value Changed");
    console.log(newValue);
    console.log(`action: ${actionMeta.action}`);
    console.groupEnd();
    setValue(newValue);
  };

  const handleCreate = (inputValue) => {
    console.log(inputValue);
    const newOption = {
      label: inputValue,
      value: inputValue.toLowerCase().replace(/\W/g, ""),
    };
    console.log(newOption);
    setValue(newOption);
    setOptions([...options, newOption]);
  };

  return (
    <CreatableSelect
      {...rest}
      ref={ref}
      styles={{
        ...styles(size, error, success),
        menuPortal: (base) => ({ ...base, zIndex: 9999 }),
      }}
      menuPortalTarget={document.body}
      theme={(theme) => ({
        ...theme,
        colors: {
          ...theme.colors,
          primary25: light.main,
          primary: light.main,
        },
      })}
      isClearable
      onChange={handleChange}
      onCreateOption={handleCreate}
      options={options}
      value={value}
    />
  );
});

// Setting default values for the props of SuiSelect
SuiSelect.defaultProps = {
  isMulti: false,
  size: "medium",
  error: false,
  success: false,
};

// Typechecking props for the SuiSelect
SuiSelect.propTypes = {
  isMulti: PropTypes.bool,
  size: PropTypes.oneOf(["small", "medium", "large"]),
  error: PropTypes.bool,
  success: PropTypes.bool,
};

export default SuiSelect;
